module.exports = __webpack_public_path__ + "media/images/lp/ashinaga-aai/home/home-bb-movie-icon-f2ec44477632da8c00acebac750857a3.svg";